import { BillingCycle } from '_gql'
import * as yup from 'yup'

import { accountingSoftware, annualRevenue } from '@sputnik/schema/creditApplication/businessInfo'
import { desiredCredit, expectedSpend } from '@sputnik/schema/creditApplication/financeInfo'

export const businessInfo = yup.object().shape({
  annualRevenue: annualRevenue.nullable(),
  accountingSoftware: accountingSoftware.nullable(),
})

const financeInfo = yup.object().shape({
  desiredCredit: desiredCredit.nullable(),
  expectedSpend: expectedSpend.nullable(),
})

export const financeDetailsFormValidationSchema = yup.object().shape({
  billingCycle: yup.string().oneOf(Object.values(BillingCycle)).nullable(),
  businessInfo: businessInfo.nullable(),
  financeInfo: financeInfo.nullable(),
})

export type FinanceDetailsFormValidationSchema = yup.InferType<typeof financeDetailsFormValidationSchema>
